// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5896) return "static/chunks/5896-c333a1e779786afc.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"6335":"3f0f62fcb6da84b0","6833":"bfbcc2cb9536d85f","7012":"a4e3c57366f4bfd2","9350":"48b3231ba281f182"}[chunkId] + ".js";
};